(function ($) {
    $.fn.displaychoice = function () {

        return this.each(function () {
            var myDisplaychoice = $(this);

            $(myDisplaychoice).bind('change', function (event) {
                let value = $(this).val();
                let name = $(this).attr('name');
                let regexWithoutBrackets = new RegExp(/\[(.*?)\]/gm);
                let resultRegex = null;
                if ((resultRegex = regexWithoutBrackets.exec(name)) !== null) {
                    name = resultRegex[1];
                }
                name = name.replace(/([ #;?&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
                let $item = $('[data-displaychoice-parent=' + name + ']');

                if ($(this).is(':checked')) {
                    $.each($item, function (index, item) {
                        datas = $(item).data('displaychoice-values');
                        for (let i in datas) {
                            if (datas[i] == value) {
                                $(item).css('display', 'block');
                                $(item).trigger('visible')
                            } else {
                                $(item).css('display', 'none');
                                $(item).trigger('hidden')
                            }
                        }
                    });
                } else {
                    $item.css('display', 'none');
                }

            }).change();

            return myDisplaychoice;
        });

    };

}(jQuery));
